'use client';

import React from 'react';
import { Grid, GridItem } from '../../../../ui';
import styled from '@emotion/styled';
// eslint-disable-next-line no-restricted-imports
import { useRouter } from 'next/router';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { IPressRelease } from '../../../shared/api/contentful/types/IPressRelease';
import PressReleaseCard from './press-release/PressReleaseCard';
import NewsSectionWrapper from './NewsSectionWrapper';
import NewsCardNoImage from '../../../../../assets/icons/no-image.svg?reference';
import Responsive from '../../../../ui/utils/Responsive';

export interface IPressReleaseProps {
	pressReleases: IPressRelease[];
}

export const PressReleasesSection = ({ pressReleases }: IPressReleaseProps) => {
	const { t } = useTranslation();
	const isMobileXL = Responsive.useMatchesBreakpoint('mobileXL');
	const router = useRouter();
	if (!pressReleases || pressReleases.length === 0) {
		return null;
	}

	const list = isMobileXL ? pressReleases.slice(0, 5) : pressReleases;

	return (
		<NewsSectionWrapper
			title={t('newsroom_press_release_title')}
			label={t('newsroom_press_release_label')}
			viewAllButtonLabel={t('web_view_all_press_releases')}
			viewAllHref={`${router.asPath}press-releases`}
		>
			<StyledFixedGrid>
				{list.map((item) => {
					const imageSrc =
						item.images?.[0]?.fields?.file?.url || NewsCardNoImage;
					return (
						<StyledFixedGridItem
							columns={[6, { mobileXL: 12 }]}
							key={item.slug}
						>
							<PressReleaseCard
								title={item.title}
								publicationDate={item.publicationDate}
								linkHref={`${router.asPath}press-releases/item/${item.slug}`}
								imageSource={imageSrc}
							/>
						</StyledFixedGridItem>
					);
				})}
			</StyledFixedGrid>
		</NewsSectionWrapper>
	);
};

const StyledFixedGrid = styled(Grid.withComponent('ul'))`
	margin-top: 32px;
	margin-left: 0;
	padding-left: 0;
	list-style: none;
	justify-content: space-between;
	row-gap: 24px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-bottom: 16px;
	}
`;

const StyledFixedGridItem = styled(GridItem.withComponent('li'))`
	display: block;
	margin-top: 0;
	margin-left: 0;
	padding-left: 0;
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		flex-basis: 100%;
	}
`;
